import React from "react";
import styled from "@emotion/styled";

const Container = styled.div`
  width: 100%;
  color: white;
  background: rgba(0, 0, 0, 0.9);
  font-size: 16px;
  box-sizing: border-box;
`;

const LogoContainer = styled.div`
  position: absolute;
  padding: 4px 10px 0;
  background: rgba(0, 0, 0, 0.3);
  bottom: -24px;
  border-radius: 0 0 5px 5px;
  right: 0;

  img {
    width: 70px;
  }
`;

const DurationBar = styled.div<{ duration: number }>`
  width: 100%;
  height: 3px;
  background: #ccc;
  position: relative;

  &::before {
    content: " ";
    position: absolute;
    bottom: 0;
    left: 0;
    height: 3px;
    width: ${(props) => props.duration}%;
    background: #52abd5;
    transition: width linear 1s;
  }
`;

type Props = {
  duration: number;
};

const AdFooter: React.FC<Props> = ({ duration }) => {
  const [remaining, setRemaining] = React.useState<number>(duration);

  React.useEffect(() => {
    const interval = setInterval(
      () => setRemaining((current) => current - 1),
      1_000,
    );
    return () => clearInterval(interval);
  }, [duration]);

  return (
    <Container>
      <DurationBar duration={(remaining * 100) / duration} />
      <LogoContainer>
        <img
          src="https://static.livepix.gg/images/logo-ads-white.svg"
          alt="Logo"
        />
      </LogoContainer>
    </Container>
  );
};

export default AdFooter;
